// 此文件用于判断当前环境（测试环境/生产环境），并返回对应环境的接口域名
const development = {
  // 测试环境
  ipServer: 'http://ipinversion.fxeyeinterface.com',
  homeClient: 'https://wikidatacenter.interface003.com:32377', // 客户端地址 https://testwikidatacenter.interface003.com:32377
  testwikidatacenter: 'http://wikidatacenter.fxeyeinterface.com:32366', // 服务端接口
  ipTranslet: 'https://exportedbase.interface003.com', // 获取用户真实ip地址+ip所在国家
  host: 'http://wikiuapi.fxeyeinterface.com', // 登录
  osshost: 'https://resources1.interface003.com'
}

const production = {
  // 生产环境
  ipServer: 'http://ipinversion.fxeyeinterface.com',
  homeClient: 'https://wikidatacenter.interface003.com:32377', // 客户端地址
  testwikidatacenter: 'http://wikidatacenter.fxeyeinterface.com:32366', // 服务端接口
  ipTranslet: 'https://exportedbase.interface003.com', // 获取用户真实ip地址+ip所在国家
  host: 'http://wikiuapi.fxeyeinterface.com',
  osshost: 'https://head-sg.oss-ap-southeast-1-internal.aliyuncs.com'
}

for (const k in development) {
  if (production[k]) continue // 若生产环境存在和测试环境一样的key值，则跳过本次循环
  production[k] = development[k] // 若上述条件不满足，说明生产环境地址和测试环境地址一样，则直接复用测试环境的地址
}

export default process.env.NODE_ENV != 'production' ? development : production
